export default __webpack_public_path__ + "images/models/90b836773c9c9f25f6341845d646e733.glb";